export const getPointsCutoffDate = (currentDate: Date = new Date()): Date => {
    return new Date(currentDate.getFullYear(), 6, 15);
};

export const getCurrentSchoolYearStartDate = (currentDate: Date = new Date()): Date => {
    const cutoffDate = getPointsCutoffDate(currentDate);

    if (currentDate <= cutoffDate) {
        return new Date(currentDate.getFullYear() - 1, 6, 16);
    }
    return new Date(currentDate.getFullYear(), 6, 16);
};

export const getCurrentSchoolYearEndDate = (currentDate: Date = new Date()): Date => {
    const cutoffDate = getPointsCutoffDate(currentDate);

    if (currentDate <= cutoffDate) {
        return new Date(currentDate.getFullYear(), 6, 15);
    }
    return new Date(currentDate.getFullYear() + 1, 6, 15);
};

export const isDateInCurrentSchoolYear = (date: Date, currentDate: Date = new Date()): boolean => {
    const schoolYearStart = getCurrentSchoolYearStartDate(currentDate);
    const schoolYearEnd = getCurrentSchoolYearEndDate(currentDate);

    return date >= schoolYearStart && date <= schoolYearEnd;
};

export const calculateValidPointsForRewards = (
    balanceSheet: {
        date: string;
        points?: any;
        isClaimedReward?: boolean;
        claimedReward?: { pointsRequired: number };
    }[],
    currentDate: Date = new Date(),
): number => {
    let pointsSum = 0;
    const cutoffDate = getPointsCutoffDate(currentDate);
    const isAfterCutoff = currentDate > cutoffDate;

    balanceSheet.forEach(sheet => {
        const sheetDate = new Date(sheet.date);

        if (!isDateInCurrentSchoolYear(sheetDate, currentDate)) {
            return;
        }

        if (isAfterCutoff && sheetDate <= cutoffDate) {
            return;
        }

        if (sheet.isClaimedReward) {
            const claimedPoints = sheet.claimedReward?.pointsRequired || 0;
            pointsSum -= claimedPoints;
            return;
        }

        if (sheet.points) {
            pointsSum +=
                (Number(sheet.points.for_questions) || 0) +
                (Number(sheet.points.for_attendance) || 0) +
                (Number(sheet.points.for_ideas) || 0) +
                (Number(sheet.points.for_practices) || 0) +
                (Number(sheet.points.for_helping_others) || 0) +
                (Number(sheet.points.for_challenges) || 0) +
                (Number(sheet.points.extra_points) || 0);
        }
    });

    return Math.max(0, pointsSum);
};
